export default async function runViewTransition(element: HTMLElement, onComplete: () => void, before?: () => void, after?: () => void): Promise<void> {
	let start: ((callback?: ViewTransitionUpdateCallback) => ViewTransition) | null = null;
	const documentElement = document.documentElement;

	if ("startViewTransition" in element) {
		start = element.startViewTransition!.bind(element);

	} else if ("startViewTransition" in documentElement) {
		start = documentElement.startViewTransition!.bind(documentElement);
	}

	if (start) {
		before?.();
		await start(onComplete).finished;
		after?.();
	} else {
		onComplete();
	}
}
